<template>
  <div class="modal" v-if="show">
    <div class="modal_contain">
      <div class="title_top">
        <div></div>
        <div class="modal_title">常见问题</div>
        <div class="modal_close" @click="onClose"></div>
      </div>
      <div v-html="content" class="modal_faq"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(flag) {
        document.body.style.overflow = flag ? 'hidden' : '';
      },
    },
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 110;
  background-color: rgba(0, 0, 0, 0.7);

  .modal_contain {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 634px;
    padding: 31px 33px 58px;
    background: #fff;
    border-radius: 14px;
    transform: translate(-50%, -50%);
  }

  .title_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
  }

  .modal_title {
    color: #333;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
  }

  .modal_close {
    display: block;
    width: 29px;
    height: 29px;
    background-image: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/member/member_close.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .modal_faq {
    max-height: 600px;
    margin-top: 72px;
    overflow-y: scroll;
    color: #333;
    font-weight: 400;
    font-size: 25px;
    line-height: 43px;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
  }
}
</style>
